module.exports = "<input type=\"{{to.type||'text'}}\" class=\"c-input\" ng-model=\"model[options.key]\" ng-model-options=\"{debounce: 1000}\"/>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/input-debounced.html
 ** module id = 540
 ** module chunks = 0
 **/